import React from 'react';
import { BUTTON_TYPE, ButtonComponent } from '../ButtonComponent';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPenToSquare } from '@fortawesome/free-solid-svg-icons';

interface IEditBlockProps {
	isEditMode: boolean;
	setIsEditMode: (value:boolean) => void;
	onEditClick: () => void;
	loading?: boolean;
}

export const EditBlock = (props: IEditBlockProps): JSX.Element => {
	const { isEditMode, setIsEditMode, onEditClick, loading } = props;
	return (
		<>
			{
				isEditMode
					? (
						<div className="d-flex align-items-center">
							<ButtonComponent
								buttonName="Cancel"
								additionalClass="btn-sm"
								buttonType={BUTTON_TYPE.CANCELLED}
								onButtonClick={(): void => setIsEditMode(!isEditMode)}
							/>
							<ButtonComponent
								buttonName="Save"
								additionalClass="btn-sm ms-10 w-75px"
								onButtonClick={(): void => !loading && onEditClick()}
								loading={loading}
							/>
						</div>
					)
					: (
						<div
							className="text-danger d-flex align-items-center cursor-pointer"
							onClick={(): void => setIsEditMode(!isEditMode)}
						>
							<FontAwesomeIcon icon={faPenToSquare}/>
							<div className="ms-2 fs-6 fw-bolder">Edit</div>
						</div>
					)
			}
		</>
	);
};
